import { useEffect } from 'react';
import { postExternalApiEvent } from '../external-api-events/postExternalApiEvent';
import { MESSAGE_INPUT_STATE_CHANGED } from '../external-api-events/constants/externalApiEventTypes';

/**
 * @description Hook to post browser external message event when the message input state changes.
 * @note To prevent spamming this event we fire it only for portal 53.
 */
export const usePostExternalApiEventOnMessageInputStateChanged = ({
  shouldSendEvent,
  disabled
}) => {
  useEffect(() => {
    if (!shouldSendEvent) {
      return;
    }
    postExternalApiEvent({
      eventType: MESSAGE_INPUT_STATE_CHANGED,
      payload: {
        state: disabled ? 'disabled' : 'enabled'
      }
    });
    return () => {
      if (!shouldSendEvent) {
        return;
      }
      postExternalApiEvent({
        eventType: MESSAGE_INPUT_STATE_CHANGED,
        payload: {
          state: 'hidden'
        }
      });
    };
  }, [disabled, shouldSendEvent]);
};